import FasterEvent from '../fasterEvent'
import config from '../../config'
import userStore from '@/store/modules/user.store'
import windowStore from '@/store/modules/window.store'

export default new FasterEvent(
  { id: 'play_video', revision: 2 },
  (eventBuilder, parameters) => {
    const hoursOffset = new Date().getTimezoneOffset() / 60
    let timezone = 'GMT'
    if (hoursOffset > 0) {
      timezone += '-' + hoursOffset
    } else if (hoursOffset < 0) {
      timezone += '+' + Math.abs(hoursOffset)
    }

    let osName = 'unknown'
    let manufacturer = 'unknown'
    const userAgent = window.navigator.userAgent
    if (/Windows/i.test(userAgent)) {
      osName = 'windows'
      manufacturer = 'microsoft'
    } else if (/iPhone|iPad|iPod|Mac/i.test(userAgent)) {
      osName = 'mac/ios'
      manufacturer = 'apple'
    } else if (/Android/i.test(userAgent)) {
      osName = 'android'
      manufacturer = 'google'
    } else if (/X11|Linux/i.test(userAgent)) {
      osName = 'unix'
      manufacturer = 'unix'
    }

    const deviceType = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(userAgent) ? 'mobile' : 'desktop'
    const locale = navigator.languages ? navigator.languages[0] : navigator.language

    return eventBuilder
      .dimension('tu', parameters.timeUsage)
      // .dimension('b', parameters.birthday)
      .dimension('ac', 'default')
      // .dimension('c', parameters.playlistId)
      // .dimension('pt', parameters.playerType)
      // .dimension('g', parameters.playlistGroupId)
      // .dimension('o', parameters.origin)
      // .dimension('p', parameters.profileId)
      .dimension('sid', parameters.segmentId)
      .dimension('ast', 'video')
      .dimension('ct', windowStore.state.countryCode.toLowerCase())
      .dimension('at', 'subscriber')
      .dimension('cid', parameters.videoId.toString())
      // .dimension('ti', parameters.contentTime)
      .dimension('dm', 'stream')
      .dimension('vpu', 'stream')
      .dimension('deviceType', deviceType)
      .dimension('sourceAppMarket', 'web')
      // .dimension('userId', parameters.userId)
      // .dimension('mediaNetwork', parameters.mediaNetwork)
      .dimension('activeSubscriptionSku', userStore.state.subscription.sku)
      // .dimension('activeSubscriptionPeriod', parameters.activeSubscriptionPeriod)
      .dimension('appVersion', config.appVersion)
      .dimension('timezone', timezone)
      .dimension('manufacturer', manufacturer)
      .dimension('systemLocale', locale)
      .dimension('platform', 'WEB')
      .dimension('systemOsName', osName)
      .dimension('systemOsVersion', 'unknown')
      .dimension('internetStatus', navigator.onLine ? 'online' : 'offline')
      .dimension('isLoggedIn', true)
      .dimension('appLocale', locale)
      .dimension('currentSubscriptionStatus', parameters.currentSubscriptionStatus)
      .build()
  }
)
